// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eyepassworduser {
        position: absolute;
        padding: 35px;
        right: 0%;
        font-size: 18px !important;
        top: 80%;
}

.subscriptionName {
        font-size: 13px;
        font-weight: bold;
        line-height: 30px;
}

.subscriptionSub {
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 10px;
}

.planPriceText {
        font-size: 30px;
        font-weight: bold;
}

.menuIconImageLoad {
        width: 200px;
        height: 200px;
        object-fit: contain;
}

.custom-country .stdropdown-container {
  margin-bottom: 10px !important;
  border: 1px solid rgb(229, 229, 234) !important; 
}


.custom-country .stdropdown-container:focus-visible,
.country-input:focus-visible {
  outline: none;
}

.stdropdown-item {
  font-size: 15px;
  font-family: 'Poppins';
}

.country-input {
  font-size: 13px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-left: 20px !important;
  margin-bottom: 2px;
  font-weight: 500;
}

.custom-country svg {
  width: 15px !important;
  height: 15px !important;
}

.admin-phone-input-wrapper .react-tel-input .form-control.admin-phone-input {
  width: 100% !important;
  height: 52px !important;
  padding-left: 58px !important;
  border: 1px solid rgb(229, 229, 234) !important;
  font-size: 14px !important;
  box-shadow: none !important;
}

.admin-phone-input-wrapper .react-tel-input .flag-dropdown.admin-phone-button {
  border: 1px solid rgb(229, 229, 234) !important;
  border-right: 0 !important;
  background: transparent !important;
}

.admin-phone-input-wrapper .react-tel-input .selected-flag {
  padding-left: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Account/User/AddUser.css"],"names":[],"mappings":"AAAA;QACQ,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,0BAA0B;QAC1B,QAAQ;AAChB;;AAEA;QACQ,eAAe;QACf,iBAAiB;QACjB,iBAAiB;AACzB;;AAEA;QACQ,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;AAC3B;;AAEA;QACQ,eAAe;QACf,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,aAAa;QACb,mBAAmB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+CAA+C;AACjD;;;AAGA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+CAA+C;EAC/C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".eyepassworduser {\n        position: absolute;\n        padding: 35px;\n        right: 0%;\n        font-size: 18px !important;\n        top: 80%;\n}\n\n.subscriptionName {\n        font-size: 13px;\n        font-weight: bold;\n        line-height: 30px;\n}\n\n.subscriptionSub {\n        font-size: 12px;\n        line-height: 20px;\n        font-weight: 400;\n        margin-bottom: 10px;\n}\n\n.planPriceText {\n        font-size: 30px;\n        font-weight: bold;\n}\n\n.menuIconImageLoad {\n        width: 200px;\n        height: 200px;\n        object-fit: contain;\n}\n\n.custom-country .stdropdown-container {\n  margin-bottom: 10px !important;\n  border: 1px solid rgb(229, 229, 234) !important; \n}\n\n\n.custom-country .stdropdown-container:focus-visible,\n.country-input:focus-visible {\n  outline: none;\n}\n\n.stdropdown-item {\n  font-size: 15px;\n  font-family: 'Poppins';\n}\n\n.country-input {\n  font-size: 13px !important;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n  padding-left: 20px !important;\n  margin-bottom: 2px;\n  font-weight: 500;\n}\n\n.custom-country svg {\n  width: 15px !important;\n  height: 15px !important;\n}\n\n.admin-phone-input-wrapper .react-tel-input .form-control.admin-phone-input {\n  width: 100% !important;\n  height: 52px !important;\n  padding-left: 58px !important;\n  border: 1px solid rgb(229, 229, 234) !important;\n  font-size: 14px !important;\n  box-shadow: none !important;\n}\n\n.admin-phone-input-wrapper .react-tel-input .flag-dropdown.admin-phone-button {\n  border: 1px solid rgb(229, 229, 234) !important;\n  border-right: 0 !important;\n  background: transparent !important;\n}\n\n.admin-phone-input-wrapper .react-tel-input .selected-flag {\n  padding-left: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
